import { scrollTo } from 'Models/scroll';

export default function initHashAnchorNavigation () {
    checkForAnchor();
    document.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', anchorLinkClickHandler);
    });
}

function anchorLinkClickHandler (e) {
    const href = e.currentTarget.getAttribute('href');
    if (href && href.length && href[0] === '#') {
        const hashId = href.split('#')[1];
        const anchorSection = document.querySelector(`[data-id="${hashId}"]`);
        if (anchorSection) {
            e.preventDefault();
            scrollTo(anchorSection);
        }
    }
}

function checkForAnchor () {
    if (window.location.hash.length) {
        window.scrollTo(0, 0); // execute it straight away
        setTimeout(function () {
            window.scrollTo(0, 0); // run it a bit later also for browser compatibility
        }, 1);
        const hashId = window.location.hash.split('#')[1];
        const anchorSection = document.querySelector(`[data-id="${hashId}"]`);
        if (anchorSection) {
            setTimeout(() => {
                scrollTo(anchorSection);
            }, 500);
        }
    }
}
